import { render, staticRenderFns } from "./MacroSettings.vue?vue&type=template&id=df823532&"
import script from "./MacroSettings.vue?vue&type=script&lang=ts&"
export * from "./MacroSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports